import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/home.png'
import _imports_1 from '@/assets/img/profile.png'
import _imports_2 from '@/assets/img/legal.png'
import _imports_3 from '@/assets/img/logout.png'


const _withScopeId = n => (_pushScopeId("data-v-627a8a4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "aria-labelledby": "Bottm touch nav" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav__icon",
  src: _imports_0,
  alt: "home"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav__text" }, "Home", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav__icon",
  src: _imports_1,
  alt: "profile"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav__text" }, "Profile", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav__icon",
  src: _imports_2,
  alt: "legal"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav__text" }, "Legal", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav__icon logout",
  src: _imports_3,
  alt: "logout"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav__text" }, "Logout", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

import { useMsal } from '@/msal/useMsal';
import { useDefaultStore } from '@/store';
import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {
const {instance} = useMsal()
const store = useDefaultStore()
const router = useRouter()

const checkActive = (nav: string) => store.getCurrentView === nav
const setActive = (nav: string) => {
    store.setCurrentView(nav)
    if (nav === 'home') {
        router.push('/')
    } 
    else
    {
        router.push(`/${nav}`)
    }
}
const logout = () => {
    store.setCurrentView('logout')
    instance.logoutRedirect()
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("a", {
      class: _normalizeClass(["nav__link", {'nav__link--active' : checkActive('home')}]),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (setActive('home')), ["prevent"])),
      href: "/"
    }, _hoisted_4, 2),
    _createElementVNode("a", {
      class: _normalizeClass(["nav__link", {'nav__link--active' : checkActive('profile')}]),
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (setActive('profile')), ["prevent"])),
      href: "/Profile"
    }, _hoisted_7, 2),
    _createElementVNode("a", {
      class: _normalizeClass(["nav__link", {'nav__link--active' : checkActive('legal')}]),
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (setActive('legal')), ["prevent"])),
      href: "/Legal"
    }, _hoisted_10, 2),
    _createElementVNode("a", {
      class: _normalizeClass(["nav__link", {'nav__link--active' : checkActive('logout')}]),
      onClick: _withModifiers(logout, ["prevent"]),
      href: "#"
    }, _hoisted_14, 10, _hoisted_11)
  ]))
}
}

})